import React from 'react';
import AuthStore from 'stores/AuthStore';
import DepartmentStore from 'stores/department/DepartmentStore';
import DepartmentActions from 'actions/department/DepartmentActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import {UserContextType} from 'components/triggers/UserContextType';

class UserInDepartmentComponent extends React.Component {
  static getStores() {
    return [DepartmentStore];
  }

  static getPropsFromStores(nextProps) {
    const {context, contextType} = nextProps;
    const isAdmin = AuthStore.getState().user.isAdmin();
    const {areDepartmentProfilesLoaded, areDepartmentProfilesLoading, departmentProfiles} =
      DepartmentStore.getState();
    if (!areDepartmentProfilesLoaded && !areDepartmentProfilesLoading) {
      DepartmentActions.fetchDepartmentProfiles.defer(isAdmin);
    }
    const department = departmentProfiles.find(d => d.id === context.department_id);
    return {department, contextType};
  }

  render() {
    const {department, contextType} = this.props;
    if (!department) {
      return null;
    }
    return (
      <div>
        {contextType === UserContextType.USER && (
          <span>
            a member of department{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              {department.name}
            </span>{' '}
            reviews a call
          </span>
        )}
        {contextType === UserContextType.CALLER && (
          <span>
            is placed or received by a member of department{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              {department.name}
            </span>
          </span>
        )}
        {contextType === UserContextType.CALL && (
          <span>
            the call is placed or received by a member of department{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              {department.name}
            </span>
          </span>
        )}
      </div>
    );
  }
}

export default connectToStores(UserInDepartmentComponent);
